import {Triarc} from "../../Cirrus/utils/CommonUtils";
import {EExternalProjectType, EStampType, ICreateStampVm} from '../Data/Data';

export class TimeQueueItem {
  id : string;
  constructor(public typeId: number,
              public projectId: number,
              public projectType: EExternalProjectType,
              public employeeId: number,
              public date: Date,
              public stampType: EStampType,
              public locationId?: number,
              public fixedPositionNumber?: number) {

    this.id = Triarc.generateGuid();
  }

  static toTimeEntryModel(item: TimeQueueItem): ICreateStampVm {
    const date = new Date(item.date.toString());
    return {
      typeId: item.typeId,
      projectId: item.projectId,
      projectType: item.projectType,
      employeeId: item.employeeId,
      elapsedSeconds: ((new Date().getTime() - date.getTime()) / 1000),
      id: item.id,
      clientTimeStamp : date,
      locationId: item.locationId,
      stampType: item.stampType,
      fixedPositionNumber: item.fixedPositionNumber
    };
  }
}
